import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrganizationService } from '../organization.service';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
    selector: 'app-deactivate-organization-dialog',
    templateUrl: './deactivate-organization-dialog.component.html',
    styleUrls: ['./deactivate-organization-dialog.component.css'],
    standalone: false
})

export class DeactivateOrganizationDialogComponent {
  selectedReason: string = '';
  comments: string = '';
  showCommentError: boolean = false;
  isDeactivating = false; // Add this at the top of your component
  deactivationReasons: string[] = [
    'Duplicate organization',
    'Organization closed',
    'No longer in use',
    'Merged with another organization',
    'Created by mistake',
    'Inactive for a long time',
    'Changed business structure',
    'Not complying with policies',
    'Other'
  ];

  constructor(
    public dialogRef: MatDialogRef<DeactivateOrganizationDialogComponent>,
    private snackBar: MatSnackBar,
    private organizationService: OrganizationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  cancel(): void {
    this.dialogRef.close();
  }



  async confirmDeactivation(): Promise<void> {
    this.showCommentError = false;
  
    // Validate selected reason
    if (!this.selectedReason) return;
  
    // If "Other" is selected, comments are required
    if (this.selectedReason === 'Other' && !this.comments.trim()) {
      this.showCommentError = true;
      return;
    }
  
    const reason = this.selectedReason === 'Other' ? this.comments.trim() : this.selectedReason;
    const comments = this.comments?.trim() || '';
  
    const payload = {
      id: this.data?.organizationId,
      status: '0',
      userId: this.data?.userId,
      deactivateReasons: reason,
      comments: comments
    };
  
    this.isDeactivating = true;
  
    try {
      await this.organizationService.changeOrganizationStatus(payload);
      const successMessage = 'Organization deactivated successfully';
      this.dialogRef.close({ status: true, message: successMessage });
    } catch (error) {
      console.error('Deactivation failed:', error);
      const errorMessage = error?.error?.message || 'Failed to deactivate organization. Please try again.';
      this.dialogRef.close({ status: false, message: errorMessage });
    } finally {
      this.isDeactivating = false;
    }
  }
  
  

  
}
 